import { Ref, computed, ref } from 'vue';
import { Swiper } from 'swiper';

export default function useSwiperSlideDynamicUnderline(swiper: Ref<Swiper | null>) {
    const activeIndex = ref<number>(0);
    const hoverIndex = ref<number>(0);
    const slides = computed(() => swiper.value?.slides);
    const targetXPosition = computed(() => (slides.value?.[hoverIndex.value] as HTMLElement)?.offsetLeft ?? 0);
    const targetWidth = computed(() => slides.value?.[hoverIndex.value]?.clientWidth ?? 0);

    const setActiveIndex = (index: number) => {
        activeIndex.value = index;
        hoverIndex.value = index;
    };

    const setUnderlineAnimation = (index: number) => {
        hoverIndex.value = index;
    };

    const removeUnderline = () => {
        hoverIndex.value = activeIndex.value;
    };

    return {
        removeUnderline,
        setUnderlineAnimation,
        targetWidth,
        targetXPosition,
        setActiveIndex,
    };
}
